import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Divider, Notification, StackView, Typography } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import SectionHeading from '../sectionHeading';
import Table from './components/table';
import FieldGuide from '../../../form/fields/common/fieldGuide';

const GeotabBundles = ({
  itemsList,
  contentfulError,
  viewType,
  installServices,
  setInstallServices,
  total,
  setTotal
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    iotOrderDetailsSection: { geotabBundlesHeading }
  } = localizedStrings;
  const header =
    itemsList.find(item => _.get(item, 'fields.isHeader', false)) || {};
  const toolTip = _.get(header, 'fields.toolTip', '');

  return (
    <>
      {contentfulError && (
        <Notification variant={{ validation: 'error' }}>
          Error fetching data from contentful
        </Notification>
      )}

      {!contentfulError && itemsList.length > 0 && (
        <>
          <StackView space={3}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <SectionHeading><Typography heading="h4" variant={{ size: 'h4' }} block>{geotabBundlesHeading}</Typography></SectionHeading>
              {toolTip && <FieldGuide tooltip={toolTip} />}
            </div>
            <Table
              viewType={viewType}
              service={installServices}
              setService={setInstallServices}
              list={itemsList}
              total={total}
              setTotal={setTotal}
            />
          </StackView>
          <Divider space={3} variant={{ inverse: true }} />
        </>
      )}
    </>
  );
};

GeotabBundles.propTypes = {
  itemsList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  contentfulError: PropTypes.shape({}).isRequired,
  viewType: PropTypes.string.isRequired,
  installServices: PropTypes.shape({}).isRequired,
  setInstallServices: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  setTotal: PropTypes.func.isRequired
};

export default GeotabBundles;
